let customerFieldNames = []

/* EXTRA FIELD HELPERS */
// Seek by field name the customer input field
const fetchCustomerLabel = (formId, fieldName) => {
  const $input = document.querySelector(
    `[kr-form="${formId}"] input.kr-theme[name="${fieldName}"]`
  )
  return $input
}

window.KR_CONFIGURATION = {
  button: {
    template: `<span>{label} {price}</span>`,
    animation: `<krypton-button-animation type="bubbles" />`
  },
  fields: {
    custom: {
      template: `
            <div @show="isVisible" @class="{'kr-visible':isVisible}" class="kr-field kr-text kr-field-wrapper">
                <div class="kr-icon" @class="{'kr-error':isInvalid}">
                    <krypton-icon icon-class="fa fa-{attribute.kr-icon}"></krypton-icon>
                </div>
                <div class="kr-input-wrapper">
                    {slot}
                </div>
            </div>
            `,
      events: {
        onMounted: (fieldName, $input) => {
          // Show the input
          $input.show()
          //Add customer Field list
          customerFieldNames.push($input.attr('name'))
        },
        onFocus: (formId, fieldName, $input) => {
          if (~customerFieldNames.indexOf(fieldName)) {
            const $elem = document.querySelector(
              `[kr-form="${formId}"] .kr-field input.kr-theme[name="${fieldName}"]`
            )
            if ($elem) $elem.focus()
          }
        },
        onInput: (formId, fieldName, $input) => {
          const $customerLabel = fetchCustomerLabel(formId, fieldName)
          if ($customerLabel) {
            const $elem =
              $customerLabel.parentElement.parentElement.querySelector(
                '.kr-icon'
              )
            if ($elem) $elem.classList.remove('kr-error')
          }
        }
      }
    },
    checkbox: {
      type: 'switch',
      template: `
            <div @show="isVisible" @class="{'kr-visible':isVisible}" class="kr-field kr-checkbox kr-checkbox-type-switch">
                <div class="kr-field-wrapper">
                    <div class="kr-checkbox-input-wrapper">
                        <label class="kr-field-control kr-checkbox">
                            {slot}
                            <div class="kr-checkbox-control-indicator"></div>
                            {attribute.label}
                        </label>
                    </div>
                </div>
            </div>
            `
    },
    radio: {
      template: `
        <div @show="isVisible" @class="{'kr-visible':isVisible}" class="kr-field kr-radio">
          {slot}
          <div class="kr-radio-control-indicator">
            <div class="kr-checked"></div>
          </div>
          <label for="{attribute.id}"> {attribute.label} </label>
        </div>
      `
    },
    events: {
      onUpdate: data => {
        const $items = document.querySelectorAll('.kr-form-error, .kr-icon')
        if ($items) {
          for (let i = 0; i <= $items.length - 1; i++) {
            $items[i].classList.remove('kr-form-error-visible')
            $items[i].classList.remove('kr-error')
          }
        }
      }
    }
  },
  events: {
    // Listen to 3ds visibility changes (extra field visibility on popin)
    onCheckoutShow: data => {
      const $fields = document.querySelectorAll(
        '.kr-embedded[kr-popin] .kr-wrapper-custom-field .kr-field'
      )
      if ($fields) {
        for (let i = 0; i <= $fields.length - 1; i++) {
          $fields[i].style.display = 'none'
        }
      }
    },
    onCheckoutHide: data => {
      const $fields = document.querySelectorAll(
        '.kr-embedded[kr-popin] .kr-wrapper-custom-field .kr-field'
      )
      if ($fields) {
        for (let i = 0; i <= $fields.length - 1; i++) {
          $fields[i].style.display = 'block'
        }
      }
    },
    // event onPopinClose is when the popin is removed
    onPopinClose: message => {
      const $error = document.querySelector('.kr-form-error')
      if ($error) {
        $error.classList.remove('kr-animated')
        $error.classList.remove('kr-flipInX')
        $error.classList.remove('kr-form-error-visible')
      }
    },
    onError: data => {
      const $error = document.querySelector('.kr-form-error')
      if ($error) {
        $error.classList.add('kr-animated')
        $error.classList.add('kr-flipInX')
        $error.classList.add('kr-form-error-visible')
      }
    }
  },
  merchant: {
    header: {
      image: {
        type: 'logo',
        src: 'data:image/svg+xml;base64,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'
      },
      shopName: {
        color: '#444',
        visibility: true
      },
      orderId: {
        visibility: false
      },
      amount: {
        visibility: false
      },
      backgroundColor: '#E4E4E4'
    }
  },
  form: {
    brand: {
      visibility: true
    },
    placeholdersMinWidth: {
      securityCode: 117
    },
    // redirection modal
    redirection: {
      header: {
        closeBtn: {
          margin: null
        }
      }
    },
    smartButton: {
      button: {
        spinnerVisible: true
      }
    },
    smartform: {
      overlay: {
        logo: {
          visibility: true
        }
      },
      modal: {
        backButton: {
          height: '46px',
          $redirect: {
            height: '46px'
          }
        }
      },
      radioButton: {
        visibility: true
      }
    }
  },
  // Overrides the root conf for popin form
  popin: {
    form: {
      layout: 'compact'
    }
  },
  // Overrides the root conf for smart form
  smartform: {
    merchant: {
      header: {
        backgroundColor: '#F4F4F4',
        orderId: {
          color: '#444',
          visibility: true
        },
        amount: {
          color: 'var(--kr-global-color-primary)',
          visibility: true
        }
      }
    }
  },
  theme: {
    name: 'classic',
    version: 'V4.15.1'
  },
  smartForm: {
    otherPaymentMethods: {
      grid: {
        button: {
          $singlePaymentButton: {
            threshold: {
              small: 240
            }
          },
          minWidth: 60,
          paddingRight: 10,
          paddingY: 5
        }
      }
    }
  }
}
